import React from "react";
import {classes, style, vars} from './doppe-page-profile-picture.st.css';
import {DoppePageProfilePictureSource} from "../../client-server-common";
import {
    DoppePageProfilePictureMediaView
} from "../doppe-page-profile-picture-media-view/doppe-page-profile-picture-media-view";
import {BymoPageLayout} from "../bymo-page-style/bymo-page-style";

export const DoppePageProfilePicture = React.memo(function DoppePageProfilePicture (props: DoppePageProfilePicture.Props) {
    const {
        profilePicture,
        size = 100,
        sizeOnWideLayout,

        style: styleProp,
        className,
        ...htmlAttributes
    } = props;

    const normalizedSizeOnWideLayout = sizeOnWideLayout ?? size;

    return (
        <DoppePageProfilePictureMediaView
            {...htmlAttributes}
            className={style(classes.root, className)}
            style={{
                [vars.width]: `${size}px`,
                [vars.wideLayoutWidth]: `${normalizedSizeOnWideLayout}px`,
                ...styleProp
            }}
            profilePicture={profilePicture}
            layoutSpec={{
                widthHeightRatio: 1
            }}
            widthSpec={layout => ({
                width: layout === BymoPageLayout.Wide ? normalizedSizeOnWideLayout : size
            })}
        />
    )
});

export namespace DoppePageProfilePicture {

    export interface Props extends React.HTMLAttributes<any> {
        profilePicture: DoppePageProfilePictureSource;
        size?: number;
        sizeOnWideLayout?: number;
    }
}
